import React, { FC, useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import "../../static/css/TilesDetails.css";
import Button from "./Button";

import "../../static/css/tooltip.css";
import DetailIcon from "../../static/svg/DetailIcon";
import ArchiveIcon from "../../static/svg/ArchiveeIcon";
import BuildIcon from "../../static/svg/BuildIcon";
import BuildcrewIcon from "../../static/svg/BuildcrewIcon";

import { toast } from "react-toastify";
import { service } from "../../../services/AxiosServices";
import Knowledgehubconfiguration from "../../static/svg/Knowledgehubconfiguration";
import FinetuningIcon from "../../static/svg/FinetuningIcon";
import PlayIcon from "../../static/svg/PlayIcon";
import AccessControl from "../molecules/AccessControl";
interface Props {
  id: number;
  title: string;
  phase?:number;
  description: string;
  category?: string;
  onDelete: (id: number) => void;
}
// DashboardCards displays a card with title, description, action buttons for edit, delete,
// and navigate to specific sections based on the category (AI space or AI crew).

const DashboardCards: FC<Props> = ({
  title,
  phase,
  description,
  id,
  category,
  onDelete,
}) => {
  const navigate = useNavigate();
  const isAiSpace = category === "knowledge-hubs";
  const isAiCrew = category === "crews";
  const [loading, setLoading] = useState(false);
  const [userRoles, setUserRoles] = useState<any>([]);

  useEffect(() => {
    const userData = localStorage.getItem("user_account");
    if (userData) {
      const parsedUser = JSON.parse(userData);
      setUserRoles(parsedUser.roles || []);
    }
  }, []);
  const analysePhase = phase === 0;
  const preparePhase = phase === 1;
  const buildPhase = phase === 2;

  const crewTrainingPhase = phase === 3;
  const crewFineTunePhase = phase === 4;
  const crewDeployPhase = phase === 5;

  const spacetrainingPhase = phase === 3;
  const spaceFinetunePhase = phase === 4;
  const spaceDeployPhase = phase === 5;

  const handleClick = async (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    if (isAiSpace) {
      navigate(`/space/${id}`);
    } else if (isAiCrew) {
      navigate(`/edit_crew/${id}`);
    }
  };
  const handleEdit = () => {
    if (isAiSpace) {
      navigate(`/space/${id}`, { state: { title } });
    } else if (isAiCrew) {
      navigate(`/edit_crew/${id}`, { state: { title } });
    }
  };
  const handleDelete = async (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    try {
      let response;
      if (isAiCrew) {
        response = await service(
          `/api/crew/delete`,
          "delete",
          null,
          "application/json",
          id
        );
      } else {
        response = await service(`/api/delete-space`, "post", {
          space_id: id,
        });
      }
      toast.success(
        isAiCrew
          ? "Crew deleted successfully"
          : "Knowledge hub deleted successfully",
        { autoClose: 2000 }
      );

      onDelete(id);
    } catch (err) {
      toast.error("Failed to delete the item. Please try again.", {
        autoClose: 2000,
      });
    }
  };

  const handleSpace = (e:React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    if (analysePhase) {
      navigate(
        isAiCrew
          ? `/crew-analyzed-records/${id}`
          : `/space-analyzed-records/${id}`
      );
    } else if (preparePhase) {
      navigate(
        isAiCrew
          ? `/crew-prepared-records/${id}`
          : `/space-prepared-records/${id}`
      );
    } else if (buildPhase) {
      navigate(`/crew-build/${id}`);
    } else if (crewTrainingPhase) {
      navigate(
        isAiCrew
          ? `/training-crew/${id}/upload`
          : `/training-space/${id}/upload`
      );
    } else if (spacetrainingPhase) {
      navigate(`/training-space/${id}/upload`);
    } else if (isAiCrew && (crewFineTunePhase)) {
      navigate(`/finetune_response/${id}`);
    } else if (isAiSpace && (spaceFinetunePhase)) {

      navigate(`/ai_space/${id}/section`, { state: { spaceName: title } });
    } else if (isAiSpace) {
      navigate(`/ai_space/${id}/section`, { state: { spaceName: title } });
    } else {
      navigate(`/response/${id}`);
    }
  };
  const handlePlay = async (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    try {
      setLoading(true);
      await service<any>(`/trigger-email-api/${id}`, "post");
      toast.success("Success!", { autoClose: 2000 });
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
 const handleTraining = async (e: React.MouseEvent<HTMLElement>,id:number)=>{
  e.stopPropagation()
  navigate(
    isAiSpace
      ? `/training-space/${id}/upload`
      : isAiCrew
      ? `/training-crew/${id}/upload`
      : ""
  )

}
const handelBuild = async(e: React.MouseEvent<HTMLElement>,id:number)=>{
  e.stopPropagation()
  navigate(
    `/crew-build/${id}`
   )
}
  const handleButtonVisibility = () => {
    const isTrainer = userRoles.includes("Trainer");
    const isBuilder = userRoles.includes("AI developer")
    const isPreparer = userRoles.includes("Preparer")
    const isFineTuner = userRoles.includes("Finetuner")
    const isAnalyzer = userRoles.includes("Analyzer")
    const isAdmin  = userRoles.includes("Admin")
    const isCadmin = userRoles.includes("C-admin")


    if (isAdmin || isCadmin) {
      return true;
    }
    if(isAnalyzer && analysePhase){
      return true
    }

   
    if(isPreparer &&  preparePhase){
      return true
    }

    if(isBuilder && buildPhase){
      return true
    }


    if (
      isTrainer &&
      (
        (isAiCrew && (crewTrainingPhase )) ||
        (isAiSpace && (spacetrainingPhase))
      )
    ) {
      return true
    }
    
    if(isFineTuner && ( 
      
     (isAiCrew && (crewFineTunePhase)) || 
     (isAiSpace && (spaceFinetunePhase))
    
    )){
      return true
    }

    return false
  };

  return (
    <>
      <div >
        <div className="Title_card mb-2">
          {title.length > 32 ? title.slice(0, 32) : title}
        </div>
        <div className="Discription_card">
          {description.length > 156 ? description.slice(0, 156) + "..." : description}
        </div>
      </div>
      <div className="d-flex justify-content-between card-button mt-auto">
        <div className="d-flex gap-2 z-3">
          <Button
            onClick={(e)=>handleClick(e)}
            title="Details"
            data-bs-toggle="tooltip"
          >
            <span className="DetailIcon me-1">
              <Knowledgehubconfiguration />
            </span>
          </Button>

          {analysePhase ||
          preparePhase ||
          buildPhase ||
          crewTrainingPhase ||
          crewFineTunePhase ||
          spaceFinetunePhase ||
          spacetrainingPhase ||
          spaceDeployPhase
          ? (
            <></>
          ) : (
            <Button
              title="Archive"
              data-bs-toggle="tooltip"
              onClick={(e)=>handleDelete(e)}
            >
              <span className="BuildIcon me-1">
                <BuildIcon />
              </span>
            </Button>
          )}

          {isAiCrew && (crewTrainingPhase || crewFineTunePhase) ? (

            <>

        <AccessControl
        requiredPermissions={[{ permission: "build", types: ["read"] }]}
        renderNoAccess={<></>}
      >
            <button
              onClick={(e) =>handelBuild(e,id)}
              title={"Build"}
              data-bs-toggle="tooltip"
            >
              <span className="BuildCrewicon me-1">
                <BuildcrewIcon />
              </span>
            </button>
            </AccessControl>
            </>
          ) : (
            <></>
          )}
       
          {crewFineTunePhase || spaceFinetunePhase || spaceDeployPhase ? (

            <>
         <AccessControl
           requiredPermissions={[{ permission:  isAiCrew ? "training" : isAiSpace ?"knowledge_hub":"", types: ["read"] }]}
          renderNoAccess={<></>}
           >
            <Button
              title="training"
              data-bs-toggle="tooltip"
              onClick={(e) => handleTraining(e,id)}
            >
              <span className="BuildIcon me-1">
                <BuildIcon />
              </span>
            </Button>
            </AccessControl>

            </>
          ) : (
            <></>
          )}

          {isAiCrew &&
          (buildPhase ||
            crewTrainingPhase ||
            crewFineTunePhase ||
            crewDeployPhase) ? (

              <>

        <AccessControl
        requiredPermissions={[{ permission: "build", types: ["read"] }]}
        renderNoAccess={<></>}
      >
            <Button onClick={handlePlay} style={{ cursor: "pointer" }}>
              {loading ? (
                <div
                  className="spinner-border p-2 m-2 spinner-border-sm text-primary"
                  role="status"
                >
                  <span className="visually-hidden"></span>
                </div>
              ) : (
                <span 
                 className="Playbuttonicon"
                title="Run the crew" data-bs-toggle="tooltip">
                  <PlayIcon />
                </span>
              )}
            </Button>
            </AccessControl>
            </>
          ) : (
            <></>
          )}
        </div>
        <AccessControl
              requiredPermissions={[
                
                { permission: (analysePhase && isAiCrew)? 'crew_analyze_documents': (analysePhase && isAiSpace)?'analyze_documents' :
                   (preparePhase && isAiCrew)? 'prepare_document': (preparePhase && isAiSpace) ? 'prepare_documents':
                   (isAiCrew &&  crewTrainingPhase ) ? 'training': ( isAiSpace && spacetrainingPhase) ? 'knowledge_hub' :
                   (isAiCrew && crewFineTunePhase) ? 'Crew_finetuning':  (isAiSpace && spaceFinetunePhase ) ? 'manage_space_chat':'',
                   types: ["read"]
                  
                  },
              ]}
              renderNoAccess={<></>}
            >
        <Button
          className={`btn px-3 ${isAiCrew ? "output-btn" : "open-btn"}`}
          onClick={(e)=>handleSpace(e)}
          style={{ display: handleButtonVisibility() ? "block" : "none" }}
        >
          {analysePhase
            ? "Let's analyze"
            : preparePhase
            ? "Let's prepare"
            : buildPhase
            ? "Let's build"
            : (crewTrainingPhase && isAiCrew) ||
              (spacetrainingPhase && isAiSpace)
            ? "Let's train"
            : (crewFineTunePhase && isAiCrew) ||
              (spaceFinetunePhase && isAiSpace)
            ? "Let's finetune"
            : crewDeployPhase && isAiCrew
            ? "Output"
            : spaceDeployPhase && isAiSpace
            ? "Let's access"
            : ""}
        </Button>

        </AccessControl>
      </div>
    </>
  );
};

export default DashboardCards;
